/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Many_Sad_Buzzard_BuildInputs */

const fr_many_sad_buzzard_build = /** @type {(inputs: Many_Sad_Buzzard_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des programmes des 2 dernières semaines`)
};

/**

* @param {Many_Sad_Buzzard_BuildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const many_sad_buzzard_build = /** @type {((inputs?: Many_Sad_Buzzard_BuildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Many_Sad_Buzzard_BuildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_many_sad_buzzard_build(inputs)
});